"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiSelectOverrides = function (_a) {
    var palette = _a.palette, spacing = _a.spacing, pxToRem = _a.typography.pxToRem;
    return ({
        select: {
            "&:focus": {
                borderRadius: undefined,
                backgroundColor: undefined,
            },
        },
        selectMenu: {
            height: undefined,
        },
        outlined: {
            // MUI uses the same for specificity
            "&&": {
                paddingRight: spacing(8),
            },
            "&.MuiInputBase-inputAdornedEnd": {
                paddingRight: spacing(16),
            },
        },
        icon: {
            top: "calc(50% - 0.5em)",
            padding: "0.14em",
            fontSize: pxToRem(30),
            color: palette.text.secondary,
        },
        iconOutlined: {
            right: spacing(2),
        },
    });
};
//# sourceMappingURL=MuiSelect.js.map